import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, formatErr } from "../lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const nav = useNavigate();
    const [pw, setPw] = useState("");
    const [pw2, setPw2] = useState("");
    const [loading, setLoading] = useState(false);
    const [err, setErr] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        if (!token) {
            setErr("Lien invalide — token manquant.");
            return;
        }
        if (pw.length < 6) {
            setErr("Mot de passe trop court (6 caractères min.)");
            return;
        }
        if (pw !== pw2) {
            setErr("Les deux mots de passe ne correspondent pas.");
            return;
        }
        setLoading(true);
        try {
            await api.post("/auth/reset-password", { token, new_password: pw });
            toast.success("Mot de passe réinitialisé ! Connectez-vous.");
            nav("/login");
        } catch (e) {
            setErr(formatErr(e.response?.data?.detail));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-[78vh] flex items-center justify-center px-6 py-16">
            <div className="w-full max-w-md">
                <div className="text-[11px] uppercase tracking-[0.25em] text-orange-500 font-bold mb-2">
                    Nouveau mot de passe
                </div>
                <h1 className="font-display text-5xl uppercase tracking-tight mb-8">
                    Choisissez un nouveau mot de passe
                </h1>
                <form onSubmit={submit} className="card-tu space-y-5">
                    <div>
                        <label className="label-tu">Nouveau mot de passe</label>
                        <input
                            data-testid="reset-pw"
                            type="password"
                            required
                            value={pw}
                            onChange={(e) => setPw(e.target.value)}
                            className="input-tu"
                            placeholder="6 caractères min."
                            minLength={6}
                        />
                    </div>
                    <div>
                        <label className="label-tu">Confirmation</label>
                        <input
                            data-testid="reset-pw2"
                            type="password"
                            required
                            value={pw2}
                            onChange={(e) => setPw2(e.target.value)}
                            className="input-tu"
                            placeholder="Retapez le mot de passe"
                            minLength={6}
                        />
                    </div>
                    {err && (
                        <div data-testid="reset-error" className="text-sm text-red-500 border border-red-900/50 bg-red-950/30 p-3">
                            {err}
                        </div>
                    )}
                    <button
                        data-testid="reset-submit"
                        disabled={loading || !token}
                        className="btn-primary w-full"
                    >
                        {loading ? "Réinitialisation…" : "Réinitialiser le mot de passe"}
                    </button>
                    <div className="text-center">
                        <Link
                            to="/login"
                            className="text-xs uppercase tracking-widest text-zinc-400 hover:text-orange-500"
                        >
                            Retour à la connexion
                        </Link>
                    </div>
                </form>
            </div>
        </div>
    );
}
